import Image from 'next/image'
import { ICON_COMPLETED_STAMP } from '../../../../../modules/images'

const ChallengeStamp = ({ label, isStamped, reward, outerHeight = 60, innerHeight = 48, stampImg = null }) => {
  const isPointStamp = REWARD_STAMP_ICON?.[reward]
  const stampIcon = isPointStamp ? REWARD_STAMP_ICON[reward] : ICON_COMPLETED_STAMP

  return (
    <div className="relative">
      <div
        className="flex items-center justify-center border-[2.5px] border-gray-300 rounded-full"
        style={{ height: outerHeight, width: outerHeight }}
      >
        <div
          className="flex items-center justify-center border-[1.5px] border-dashed rounded-full"
          style={{ height: innerHeight, width: innerHeight }}
        >
          <span className="Title2-18Md text-gray-300">{label}</span>
        </div>
      </div>

      {stampImg && (
        <div className="absolute top-0 left-0" style={{ height: outerHeight, width: outerHeight }}>
          <Image src={stampImg} width={innerHeight} height={innerHeight} className="w-full h-full" alt="stamp" />
        </div>
      )}

      {isStamped && (
        <div className="absolute top-0 left-0 animate-stamp" style={{ height: outerHeight, width: outerHeight }}>
          <Image src={stampIcon} width={innerHeight} height={innerHeight} className="w-full h-full" alt="stamp" />
        </div>
      )}
    </div>
  )
}

export default ChallengeStamp

const REWARD_STAMP_ICON = {
  5000: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1734017736276_5000Point.webp',
  10000: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1734017746332_10000Point.webp',
  15000: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1734017754761_15000Point.webp',
  20000: 'https://d38emex6h5e12i.cloudfront.net/2024-image/1734017768888_raffle.webp',
  lessonCredit: 'https://d38emex6h5e12i.cloudfront.net/2025-image/1736911566290_reward_credit.webp',
} as const
